<template>
  <!-- START EDITOR MODE START -->
  <dr-wrapper v-if="isInEditorMode" v-bind="$props" v-on="wrapOn">
    <div v-if="fileViewerData.url" class="dr-file-viewer-plug">{{ $t('vuetifyWidgets.dr-file-viewer.fileViewWidget') }}</div>
    <div v-else>{{ $t('vuetifyWidgets.dr-file-viewer.fileNotSelected') }}</div>
  </dr-wrapper>
  <!--END-->

  <dr-file-viewer-pdf
    v-else-if="fileViewerData.type === 'pdf' && isVisible"
    :class="evaluateClasses(classes)"
    :fileData="fileViewerData"
    :style="fileViewerStyle"
  />

  <!-- START| Если пустой url или не найдены даннные в дата виджета |START -->
  <dr-file-viewer-error
    v-else-if="fileViewerData.type === 'empty' || (!fileViewerData.url && isVisible)"
    :text="$t('vuetifyWidgets.dr-file-viewer.emptyFile')"
  />
  <!--END-->

  <!-- START| В случае если тип файла не верный |START -->
  <dr-file-viewer-error v-else :text="$t('vuetifyWidgets.dr-file-viewer.fileIsNotAvailable')" />
  <!--END-->
</template>

<script>
  // TODO - Удалить из моделера пакет @pdftron/pdfjs-express
  import inputMixin from '../../mixins/input-mixin'
  import baseMixin from '../../mixins/base-mixin'

  export default {
    components: {
      'dr-file-viewer-pdf': () => import('./dr-file-viewer-pdf.vue'),
      'dr-file-viewer-error': () => import('./dr-file-viewer-error')
    },

    mixins: [inputMixin, baseMixin],

    computed: {
      // Стили для fileViewer components
      fileViewerStyle() {
        return {
          width: this.model?.Width || '100%',
          height: this.model?.Height || '100%'
        }
      },
      /* Полечение текущего файла
       *** @return type Object { url, name, type }
       */
      fileViewerData() {
        // Если мы в режиме моделера
        if (this.isInEditorMode) {
          return {
            url: this.model?.FileSource,
            name: null,
            type: ''
          }
        }
        // Получить значение из дата виджета или вернуть url
        const dataFromDataSource = this.getExternalSourceField(this.model?.FileSource)
        // если не нашли данные у дата виджета
        if (dataFromDataSource === this.model.FileSource) {
          return {
            url: null,
            name: null,
            type: 'empty'
          }
        }
        
        return dataFromDataSource
      }
    }
  }
</script>

<style lang="scss">
  .dr-file-viewer-plug {
    height: 100px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #333;
  }
</style>
